import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../../utilities/props.js";
import Flyout, { useFlyoutContext } from "../Flyout/index.js";
import Dismissible from "../Dismissible/index.js";
import s from "./Popover.module.css";
import getPaddingStyles from "../../styles/padding/index.js";
const Popover = (props) => {
    const { width, variant = "elevated", triggerType = "click", position = "bottom", elevation, ...flyoutProps } = props;
    const padding = props.padding ?? (variant === "headless" ? 0 : 4);
    const trapFocusMode = props.trapFocusMode || (triggerType === "hover" ? "content-menu" : undefined);
    const paddingStyles = getPaddingStyles(padding);
    const contentClassName = classNames(s.content, !!width && s["content--has-width"], variant && s[`content--variant-${variant}`], elevation && s[`content--elevation-${elevation}`]);
    return (_jsx(Flyout, { ...flyoutProps, position: position, trapFocusMode: trapFocusMode, triggerType: triggerType, width: width, contentClassName: contentClassName, contentAttributes: { style: { ...paddingStyles?.variables } } }));
};
const PopoverDismissible = (props) => {
    const { handleClose } = useFlyoutContext();
    return _jsx(Dismissible, { ...props, onClose: () => handleClose({}) });
};
Popover.Dismissible = PopoverDismissible;
Popover.Trigger = Flyout.Trigger;
Popover.Content = Flyout.Content;
Popover.displayName = "Popover";
PopoverDismissible.displayName = "Popover.Dismissible";
export default Popover;
